export const reconciliationTypes = {
  current: "Current",
  cumulative: "Cumulative",
  changes: "Changes",
};
